import { Modal, Button, Alert } from 'antd';
import { PrinterOutlined } from '@ant-design/icons';
import DataMatrixImage from './DataMatrixImage';
import BrandLogo from '../BrandLogo';
import { hasCryptoTail } from '../../utils/dataMatrix';
import type { MarkingCode } from '../../api/marking';

interface Props {
  open: boolean;
  scans: MarkingCode[];
  onClose: () => void;
  onPrint: () => void;
  printing: boolean;
}

const MarkingThermalPreview: React.FC<Props> = ({ open, scans, onClose, onPrint, printing }) => {
  const noCrypto = scans.filter((s) => !hasCryptoTail(s.raw_code));
  return (
    <Modal
      open={open}
      title={`Предпросмотр печати марок (${scans.length} шт.)`}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Отмена
        </Button>,
        <Button
          key="print"
          type="primary"
          icon={<PrinterOutlined />}
          loading={printing}
          disabled={noCrypto.length > 0}
          onClick={onPrint}
        >
          Печать
        </Button>,
      ]}
      width={320}
      bodyStyle={{ padding: 0, maxHeight: 520, overflowY: 'auto' }}
    >
      {noCrypto.length > 0 && (
        <Alert
          type="error"
          showIcon
          style={{ margin: 12 }}
          message={`Марки без криптохвоста напечатать нельзя (${noCrypto.length} шт.)`}
          description="Уберите их из выбора. Такие марки пришли из ШУТ 1С без криптохвоста — Честный Знак их не примет."
        />
      )}
      {scans.map((scan, idx) => (
        <div
          key={scan.id}
          style={{
            background: '#f5f0e1',
            borderBottom: idx < scans.length - 1 ? '2px dashed #d9d9d9' : 'none',
            padding: 16,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 8,
          }}
        >
          <DataMatrixImage code={scan.raw_code} scale={3} />
          <div style={{ textAlign: 'center', lineHeight: 1.3 }}>
            {scan.brand && (
              <div style={{ marginBottom: 2 }}>
                <BrandLogo brand={scan.brand} size={14} />
              </div>
            )}
            <div style={{ fontSize: 12, fontWeight: 500, color: '#262626' }}>
              {scan.product_name || '—'}
            </div>
            <div style={{ fontSize: 11, color: '#595959' }}>
              {scan.container_size || '—'}
            </div>
          </div>
        </div>
      ))}
    </Modal>
  );
};

export default MarkingThermalPreview;
